/* global angular, moment */
/**
 * Created by lari on 12/06/2017.
 */
(function () {
  'use strict';
  
  angular
    .module('vcutils.sv')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcutilssv', {
        url: '/vcutilssv',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;svsearch sv="" svref="" editinplace="true"&gt;</tt></h3><div ui-view="svsearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;svsearch sv="" svref="" parentsave=""&gt;</tt></h3><div ui-view="svsearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;sveditor sv="" mode="" onClose=""&gt;</tt></h3><div ui-view="sveditview"></div>
              <h3 class="alert alert-info"><tt>&lt;svnew&gt;</tt></h3><div ui-view="svnewview"></div>
              <h3 class="alert alert-info"><tt>&lt;svlist svs="?"&gt;</tt></h3><div ui-view="svlistview"></div>
            `
          }
        },
        onEnter: ['$log', function ($log) {
          $log.debug('debug/routes - playground.vcutilssv entered');
        }]
      });
    
    
    $stateProvider
      .state('playground.vcutilssv.allcomponents', {
        url: '/allcomponents',
        resolve: {
          sv: function () {
            return '';
          },
          svref: function () {
            return '';
          },
          somesv: ['Sv', function (Sv) {
            return Sv.$find('572b31b07c01597e3e150923');
          }],
          allsvs: ['Sv', function (Sv) {
            return Sv.$search({active: true});
          }],
          parentsavesearch: function () {
            return function (sv, svref) {
              $log.debug('debug: dummy parentsave called for svsearch with: ', sv, svref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'svsearchview@playground.vcutilssv': {
            component: 'svsearch',
            bindings: {
              sv: 'sv',
              svref: 'svref',
              editinplace: 'eip'
            }
          },
          'svsearchview2@playground.vcutilssv': {
            component: 'svsearch',
            bindings: {
              sv: 'sv',
              svref: 'svref',
              parentsave: 'parentsavesearch(sv, svref)'
            }
          },
          'sveditview@playground.vcutilssv': {
            component: 'sveditor',
            bindings: {
              sv: 'somesv'
            }
          },
          'svnewview@playground.vcutilssv': {
            component: 'svnew',
            bindings: {
            }
          },
          'svlistview@playground.vcutilssv': {
            component: 'svlist',
            bindings: {
              svs: 'allsvs'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcutilssv.allcomponents entered');
        }
      });

  }// all routes

//  klammerfriedhof
}());
